import LayoutTradeAgreementsRegister from './LayoutTradeAgreementsGenerate';

export default LayoutTradeAgreementsRegister;
